module.exports = __webpack_public_path__ + "static/img/gc_personalized.252fec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_personalized.png
// module id = 308
// module chunks = 1